var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"guide",class:{
    'editor-guide': true,
    'has-error': _vm.hasError,
    'has-focus': _vm.hasFocus,
    'has-hover': _vm.hasHover,
    'is-hidden': _vm.hidden || _vm.hasFocus
  },attrs:{"title":_vm.title},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"editor-guide-body"},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.text)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }